module.exports = __webpack_public_path__ + "static/media/logo.96d187db.png";